import { useEffect, useState } from "react";
import { Box, Button, Text } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeDetail } from "../../api";

export default function NoticeDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);

  const fetchDetail = async () => {
    const res = await noticeDetail({ id });
    setData(res.data);
  };

  useEffect(() => {
    fetchDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) return null;

  return (
    <Box>
      <Text fontSize="24px" fontWeight="bold" mb="10px">
        {data.title}
      </Text>
      <Text whiteSpace="pre-line">{data.content}</Text>

      <Button mt="20px" onClick={() => navigate(`/notices/${id}/edit`)}>
        수정
      </Button>
    </Box>
  );
}
